import classNames from 'classnames';

import classes from './index.module.less';

interface Props {
	className?: string;
	type?: 'info' | 'danger' | 'warning';
	children?: any;
}

const Alert = ({ className = '', type = 'info', children = '' }: Props) => {
	return <div className={classNames(classes.alert, classes[type], className)}>{children}</div>;
};

export default Alert;
